// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"6a586427","453":"6dcbff62","557":"dfcfc6de"}[chunkId] + ".chunk.js";
};